import { render, staticRenderFns } from "./form-page.vue?vue&type=template&id=6268c34d"
import script from "./form-page.vue?vue&type=script&lang=js"
export * from "./form-page.vue?vue&type=script&lang=js"
import style0 from "./form-page.vue?vue&type=style&index=0&id=6268c34d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports